import React, { useEffect, useState } from 'react';

import { FilteringPage } from 'hse-filtering-library-frontend';
import { useParams } from 'react-router-dom';
import { Grid } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import NavigationBreadcrumb from '@components/Navigation/Breadcrumb/NavigationBreadcrumb';
import InspectedObjectDetails from '@components/ObjectDetails/InspectedObjectDetails';
import CommentsContainer from '@components/Comments/CommentsContainer';
import FilteringEntityType from '@constants/filteringEntityType';
import Page from '@constants/page';
import i18n from '@src/i18n';
import useGetInspectedObjectDetails from "@api/objectDetails/hooks/useGetInspectedObjectDetails";
import { customCellRenderer } from '@pages/ActionSummaryDetails/lifting/LiftingActionSummaryDetails';
import {ObjectTypeEnum} from "@constants/objectType";

function ReportDetails() {
  const [language, setLanguage] = useState(i18n.language);
  const { t } = useTranslation();
  const params = useParams();

  useEffect(() => {
    if (language !== i18n.language) {
      setLanguage(i18n.language);
    }
  }, [language, t]);

  const { objectDetailsDTO } = useGetInspectedObjectDetails(Number(params.uploadId), false, {
    enabled: params.uploadId !== undefined && !Number.isNaN(params.uploadId),
  });

  if (!objectDetailsDTO) {
    return null;
  }

  return (
    <>
      <NavigationBreadcrumb currentPage={Page.REPORT_DETAILS} />

      <Grid columns={2} divided stackable>
        <Grid.Row>
          <Grid.Column width={11}>
            <InspectedObjectDetails objectDetailsDTO={objectDetailsDTO} />
          </Grid.Column>
          <Grid.Column width={5}>
            <CommentsContainer />
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <FilteringPage
        type={objectDetailsDTO.objectType === ObjectTypeEnum.EQUIPMENT ? FilteringEntityType.LIFTING_ACTION_SUMMARY :
            FilteringEntityType.ELECTRICAL_ACTION_SUMMARY}
        customCellRenderer={customCellRenderer}
        additionalArgs={{
          filters: { REPORT_ID: params.uploadId },
        }}
        defaultSort={[{ sortField: 'OBSERVATION_NUMBER', sortDirection: 'ASC' }]}
        wrapDetailsText
        lang={language}
        showAggregations={false}
        filtersCollapsed
        renderSorting
        showHeaderTooltips={false}
        noFavorites
        noHelpButton
      />
    </>
  );
}

export default ReportDetails;
